import { Helmet } from "react-helmet-async";

import { DevelopmentManagerDetailsData } from "../../models";

interface PublicDevelopmentManagerDetailsMetaTagsProps {
  developmentManagerDetailsData?: DevelopmentManagerDetailsData;
}

export const PublicDevelopmentManagerDetailsMetaTags = ({
  developmentManagerDetailsData,
}: PublicDevelopmentManagerDetailsMetaTagsProps): JSX.Element | null => {
  return (
    <Helmet>
      <title>{developmentManagerDetailsData?.displayName}</title>
      <meta name="title" content={developmentManagerDetailsData?.displayName || undefined} />
      <meta name="description" content={developmentManagerDetailsData?.hero?.subtitle || undefined} />
      <script type="application/ld+json">
        {JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "Dataset",
            name: developmentManagerDetailsData?.displayName,
            description: developmentManagerDetailsData?.hero?.subtitle || undefined,
          },
          null,
          "\t"
        )}
      </script>
    </Helmet>
  );
};
